import React from "react";
import "./Blog.scss";

export default function BlogLink({ href, children }) {
  return (
    <a className="blog-link" href={href} target="_blank">
      {children}
    </a>
  );
}
